import { render, staticRenderFns } from "./pending-details.vue?vue&type=template&id=d2ca0808&"
import script from "./pending-details.vue?vue&type=script&lang=js&"
export * from "./pending-details.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports